// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-footer {
  border-radius: 0 0 15px 15px !important;
  border-top: 0 !important;
}

.attach_btn {
  border-radius: 15px 0 0 15px !important;
  background-color: #f6f7f8;
  border: 0 !important;
  color: white;
  cursor: pointer;
  padding-top: 18px;
  padding-bottom: 18px;
}

textarea.type_msg::-moz-placeholder {
  color: grey;
  opacity: 1;
  /* Firefox */
}

textarea.type_msg::placeholder {
  color: grey;
  opacity: 1;
  /* Firefox */
}

.type_msg {
  background-color: #f6f7f8;
  border: 0 !important;
  color: #9d9d9d;
  height: 60px !important;
  overflow-y: auto;
}

.type_msg:focus {
  box-shadow: none !important;
  outline: 0px !important;
}

.type_notification_badge {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background-color: #674bff;
  position: absolute;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
}

.send_btn {
  border-radius: 0 15px 15px 0 !important;
  background-color: #f6f7f8;
  border: 0 !important;
  color: white;
  cursor: pointer;
  padding-top: 18px;
  padding-bottom: 18px;
}

.input-width {
  width: 95%;
  margin-left: 15px;
}

@media only screen and (max-width: 898px) {
  .mob-search {
    display: none !important;
  }
}
/* Add these styles to your stylesheet */
.chat-container {
  margin: 10px 0;
}

.reply-section {
  margin-left: 15px;
  border-left: 3px solid #939393;
  border-radius: 5px;
}

.reply-info {
  padding: 5px;
}

.reply-user {
  margin: 0;
  font-weight: bold;
  font-size: 13px;
}

.reply-text {
  font-size: 12px;
}

.amy-top-nav {
  display: initial !important;
}

.chat-feed-wrapper {
  display: flex;
  flex-direction: column;
}

.chat-scroll-container {
  height: calc(100vh - 300px);
}

.chat-scroll-container-reply {
  height: calc(100vh - 285px);
}

.input-width {
  margin: 9px auto !important;
}

@media only screen and (max-width: 600px) {
  .amy-top-nav {
    display: inherit !important;
  }
}
@media only screen and (min-width: 600px) {
  .mob-chat {
    width: 63% !important;
  }
}
@media only screen and (max-width: 575px) {
  .input-width {
    margin: 8px auto 4px !important;
  }
  .chat-scroll-container {
    height: calc(100vh - 323px);
  }
  .chat-scroll-container-reply {
    height: calc(100vh - 317px);
  }
}`, "",{"version":3,"sources":["webpack://./src/main/webapp/app/components/common/cards/chat-card/chat-card.scss"],"names":[],"mappings":"AAAA;EACE,uCAAA;EACA,wBAAA;AACF;;AAEA;EACE,uCAAA;EACA,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,WAAA;EACA,UAAA;EACA,YAAA;AACF;;AAJA;EACE,WAAA;EACA,UAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,oBAAA;EACA,cAAA;EACA,uBAAA;EACA,gBAAA;AACF;;AAEA;EACE,2BAAA;EACA,uBAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,QAAA;EACA,WAAA;EACA,2BAAA;AACF;;AAEA;EACE,uCAAA;EACA,yBAAA;EACA,oBAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;AACF;;AAEA;EACE,UAAA;EACA,iBAAA;AACF;;AAEA;EACE;IACE,wBAAA;EACF;AACF;AAEA,wCAAA;AACA;EACE,cAAA;AAAF;;AAGA;EACE,iBAAA;EACA,8BAAA;EACA,kBAAA;AAAF;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,SAAA;EACA,iBAAA;EACA,eAAA;AAAF;;AAGA;EACE,eAAA;AAAF;;AAGA;EACE,2BAAA;AAAF;;AAIA;EAEE,aAAA;EACA,sBAAA;AAFF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE,2BAAA;AAHF;;AAMA;EACE;IACE,2BAAA;EAHF;AACF;AAMA;EACE;IACE,qBAAA;EAJF;AACF;AAOA;EACE;IACE,+BAAA;EALF;EAQA;IACE,2BAAA;EANF;EASA;IACE,2BAAA;EAPF;AACF","sourcesContent":[".card-footer {\n  border-radius: 0 0 15px 15px !important;\n  border-top: 0 !important;\n}\n\n.attach_btn {\n  border-radius: 15px 0 0 15px !important;\n  background-color: #f6f7f8;\n  border: 0 !important;\n  color: white;\n  cursor: pointer;\n  padding-top: 18px;\n  padding-bottom: 18px;\n}\n\ntextarea.type_msg::placeholder {\n  color: grey;\n  opacity: 1;\n  /* Firefox */\n}\n\n.type_msg {\n  background-color: #f6f7f8;\n  border: 0 !important;\n  color: #9d9d9d;\n  height: 60px !important;\n  overflow-y: auto;\n}\n\n.type_msg:focus {\n  box-shadow: none !important;\n  outline: 0px !important;\n}\n\n.type_notification_badge {\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background-color: #674bff;\n  position: absolute;\n  top: 50%;\n  right: 15px;\n  transform: translateY(-50%);\n}\n\n.send_btn {\n  border-radius: 0 15px 15px 0 !important;\n  background-color: #f6f7f8;\n  border: 0 !important;\n  color: white;\n  cursor: pointer;\n  padding-top: 18px;\n  padding-bottom: 18px;\n}\n\n.input-width {\n  width: 95%;\n  margin-left: 15px;\n}\n\n@media only screen and (max-width: 898px) {\n  .mob-search {\n    display: none !important;\n  }\n}\n\n/* Add these styles to your stylesheet */\n.chat-container {\n  margin: 10px 0;\n}\n\n.reply-section {\n  margin-left: 15px;\n  border-left: 3px solid #939393;\n  border-radius: 5px;\n}\n\n.reply-info {\n  padding: 5px;\n}\n\n.reply-user {\n  margin: 0;\n  font-weight: bold;\n  font-size: 13px;\n}\n\n.reply-text {\n  font-size: 12px;\n}\n\n.amy-top-nav {\n  display: initial !important;\n}\n\n// chat styles\n.chat-feed-wrapper {\n  // height: calc(100vh - 139px) !important;\n  display: flex;\n  flex-direction: column;\n  // height: 82vh !important;\n}\n\n.chat-scroll-container {\n  height: calc(100vh - 300px);\n}\n\n.chat-scroll-container-reply {\n  height: calc(100vh - 285px);\n}\n\n.input-width {\n  margin: 9px auto !important;\n}\n\n@media only screen and (max-width: 600px) {\n  .amy-top-nav {\n    display: inherit !important;\n  }\n}\n\n@media only screen and (min-width: 600px) {\n  .mob-chat {\n    width: 63% !important;\n  }\n}\n\n@media only screen and (max-width: 575px) {\n  .input-width {\n    margin: 8px auto 4px !important;\n  }\n\n  .chat-scroll-container {\n    height: calc(100vh - 323px);\n  }\n\n  .chat-scroll-container-reply {\n    height: calc(100vh - 317px);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
